import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { RadioState } from '@app/core/states/radio.state';
import { Store } from '@ngxs/store';
import moment from 'moment-timezone';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

interface DatesRange {
  from: moment.Moment;
  to: moment.Moment;
}

@Component({
  selector: 'rk-mobile-calendar-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-calendar-header.component.html',
  styleUrl: './mobile-calendar-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileCalendarHeaderComponent implements OnInit {
  @Input()
  datesRange$: Observable<DatesRange>;

  @Input()
  currentDay$: Observable<moment.Moment>;

  @HostBinding('class.tiny-header')
  @Input()
  tinyHeader = false;

  @Output()
  setCurrentDay = new EventEmitter<moment.Moment>();

  @Output()
  unTinyHeader = new EventEmitter<void>();

  datesArr: WritableSignal<moment.Moment[]> = signal([]);

  constructor(private readonly store: Store) {}

  @HostListener('click')
  onHostClick(): void {
    if (this.tinyHeader) {
      this.unTinyHeader.emit();
    }
  }
  ngOnInit(): void {
    this.datesRange$.pipe(filter(d => !!d)).subscribe(datesRange => {
      const startDate = datesRange.from
        .clone()
        .tz(this.store.selectSnapshot(RadioState.currentRadioTimezone)); // datesRange.from is initially in UTC, convert to current timezone
      this.datesArr.set([]);
      for (let i = 0; i < 7; i++) {
        this.datesArr.update(arr => [...arr, startDate.clone().add(i, 'days')]);
      }
    });
  }

  isActive(date: moment.Moment, currentDay: moment.Moment): boolean {
    return date
      .tz(this.store.selectSnapshot(RadioState.currentRadioTimezone), true)
      ?.isSame(currentDay, 'day');
  }
}
